import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { FileTypeService } from 'src/app/shared/services/file-type.service';
import { ClaimPhotoDocumentInfo, ClaimPhotoDocumentInfoModel } from '../../models/ClaimPhotoDocumentInfo';
import { DocumentInfo } from '../../models/DocumentInfo';
import { UploadDocumentParameters } from '../../models/UploadDocumentParameters';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { DocumentService } from '../../service/document.service';
import { ShowDocumentComponent } from '../show-document/show-document.component';

@Component({
  selector: 'app-claim-photos2',
  templateUrl: './claim-photos2.component.html',
  styleUrls: ['./claim-photos2.component.scss']
})
export class ClaimPhotos2Component implements OnInit {

  constructor(
    private fileTypeService : FileTypeService,
    private documentService: DocumentService,
    private customDialogService : CustomDialogService
  ) { }

  @Input() documentTypeId:number;
  @Input() isClaimArchived = false;
  @Input() claimIdentifier:string;
  @Input() extraReferenceId = '';
  @Input() extraReferenceType = 0;
  @Input() additionalToStoreReferenceId = '';
  @Input() additionalToStoreReferenceType = 0;
  @Input() proofDocumentIds = [];
  @Input() ignoreExtraReferenceIdDuringUpload = false;
  @Input() allowUpload = true;
  @Input() autoUpload = false;
  @Input() canRemove = false;
  @Input() canExport = true;

  @Output() uploadCompleted = new EventEmitter<any>();
  @Output() filesRemoved = new EventEmitter<any>();

    isLoading: boolean;
    claimPhotos: ClaimPhotoDocumentInfoModel[];
    uploadFilesSettings: UploadFilesSettings;
    
    checkedAll: boolean;
    selectedAll: boolean;

    @ViewChild("photoContent", { read: ViewContainerRef })
    public containerRef: ViewContainerRef;
    
  ngOnInit(): void {

     const uploadDocumentParameters: UploadDocumentParameters =  {
      documentTypeId: this.documentTypeId,
      referenceType: ReferenceType.Claim,
      referenceId: this.claimIdentifier?.toString(),
      claimIdentifier: this.claimIdentifier,
      otherDocumentKindName : '',
      description: '',
      proofDocumentIds: this.proofDocumentIds,
      validateProofDocumentsAutomatically: false
     
    }

    if (!this.ignoreExtraReferenceIdDuringUpload) {  
      uploadDocumentParameters.extraReferenceType = this.extraReferenceType;  
      uploadDocumentParameters.extraReferenceId = this.extraReferenceId;
    }

    if (this.additionalToStoreReferenceId) {  
      uploadDocumentParameters.additionalToStoreReferenceType = this.additionalToStoreReferenceType;  
      uploadDocumentParameters.additionalToStoreReferenceId = this.additionalToStoreReferenceId;
    }

    const photoRestrictions: FileRestrictions = {
      allowedExtensions: this.fileTypeService.image_extensions,
      maxFileSize: 20971520
    };

    this.uploadFilesSettings = {
      uploadDocumentParameters: uploadDocumentParameters,
      fileRestrictions: photoRestrictions,
      showTopButtons:true,
      autoUpload : this.autoUpload,
      showDocumentDataDialog:false,
      documentDataDialogContent:null,
      selectButtonTextKey: 'kendo.upload.selectPhotos'
    };


    this.getClaimPhotos();
   
  }

  getClaimPhotos(){
    this.isLoading = true;
    this.documentService.getClaimPhotos( this.claimIdentifier,this.documentTypeId, this.extraReferenceType, this.extraReferenceId ).subscribe(
       (res) => { 
         this.isLoading = false;
         this.claimPhotos = res;
        } );
  }

  getThumb(file:ClaimPhotoDocumentInfo){
    return "data:image/jpeg;base64," + file.thumb;
  }

  showContent(documentInfo:DocumentInfo){

    const dialogSettings: CustomDialogSettings = {
      content: ShowDocumentComponent,
      maxHeight: '98vh',
      maxWidth: '98vw',
      appendTo:this.containerRef,
      dialogInputs: {
        documentInfo : documentInfo,
        documentInfoCollection : this.claimPhotos as DocumentInfo[],
        canExport : this.canExport
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

   onCheckboxChange(e, documentInfoId: string) {
    this.claimPhotos.find((x) => x.id == documentInfoId).isSelected =
      e.target.checked;
  }

   onSelectAll(): void {
    this.selectedAll = !this.selectedAll;
    this.claimPhotos.forEach((photo) => (photo.isSelected = this.selectedAll));
  }

  onButtonDelete(): void {

    if(!this.claimPhotos.filter((photo) => photo.isSelected)?.length){
      return;
    }

    this.customDialogService.actionWithConfirmation('claims-center.claimDocumentation.doYouReallyWantToDeleteSelectedElements',
    () => {
      this.documentService
      .removeBatchClaimPhoto(
        this.claimPhotos
          .filter((photo) => photo.isSelected)
          .map((photo) => photo.id)
      )
      .subscribe(() => this.removePhotos());
        },
        this.containerRef);
  }

  removePhotos(): void {
    this.claimPhotos = this.claimPhotos.filter((x) => !x.isSelected);
    this.filesRemoved.emit();
  }

  newUploadedItem(ev:any){
    this.getClaimPhotos();
    this.uploadCompleted.emit();
  }

}
